//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import { setPluginIcon } from "@/assets/js/appFunc.js";

export default {
    components: {
        AQChip
    },
    props: {
        activity: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {};
    },
    methods: {
        setPluginIcon
    }
};
